import Vue from 'vue'
import App from './app.vue'
import router from './router'
import './registerServiceWorker'
import MdcTopAppBar from './components/mdc/mdc-top-app-bar.vue'
import MdcTabBar from './components/mdc/mdc-tab-bar.vue'
import MdcTab from './components/mdc/mdc-tab.vue'
import MdcButton from './components/mdc/mdc-button.vue'
import TopTemplate from './components/template/top-template.vue'
import WorksItem from './views/works-item.vue'
Vue.config.productionTip = false
Vue.component('mdc-top-app-bar2',MdcTopAppBar)
Vue.component('mdc-tab-bar',MdcTabBar)
Vue.component('mdc-tab',MdcTab)
Vue.component('mdc-button',MdcButton)
Vue.component('top-template',TopTemplate)
Vue.component('works-item',WorksItem)
new Vue({
  router,
  render:h => h(App),
}).$mount('#app')

router.beforeEach((to, from, next) => {
  const id = process.env.VUE_GA_TRACKING_ID
  gtag('config', id, {page_path: to.path})
  next()
})
